var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-room" }, [
    _c(
      "div",
      [
        _c("el-button", {
          attrs: { size: "mini", icon: "el-icon-close", circle: "" },
          on: { click: _vm.closeChatRoom }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.page === 1
      ? _c(
          "div",
          { staticClass: "user-list" },
          [
            _c(
              "el-button-group",
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.openSelectUser("SINGLE")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _c("span", [_vm._v("Add Single Chat")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.openSelectUser("GROUP")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _c("span", [_vm._v("Add Group Chat")])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "room-list" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingChatList,
                        expression: "loadingChatList"
                      }
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.chatRooms, stripe: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { width: "200" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c("i", { staticClass: "el-icon-s-custom" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getRoomName({
                                        id: row.chatRoomId,
                                        singleName: row.chatRoomSingleName,
                                        groupName: row.chatRoomGroupName,
                                        type: row.chatRoomType
                                      })
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2584225552
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "padding-top": "25px" } },
                                  [
                                    _c(
                                      "el-badge",
                                      {
                                        staticClass: "item",
                                        attrs: { value: row.unreadMessage }
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            icon: "el-icon-arrow-right"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openChat({
                                                id: row.chatRoomId,
                                                singleName:
                                                  row.chatRoomSingleName,
                                                groupName:
                                                  row.chatRoomGroupName,
                                                type: row.chatRoomType
                                              })
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-button", {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeRoom({
                                            id: row.chatRoomId,
                                            singleName: row.chatRoomSingleName,
                                            groupName: row.chatRoomGroupName,
                                            type: row.chatRoomType
                                          })
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        681864554
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.page === 2
      ? _c("div", [
          _c(
            "div",
            { staticClass: "chat-header" },
            [
              _c("el-button", {
                attrs: { size: "mini", icon: "el-icon-arrow-left" },
                on: { click: _vm.closeRoom }
              }),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-s-custom" }),
              _c("span", [_vm._v(_vm._s(_vm.recieverName))])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chat-list", attrs: { id: "chat-list-container" } },
            _vm._l(_vm.chats, function(chat, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: [
                    _vm.currentUser === chat.senderName
                      ? "right-box"
                      : "left-box",
                    "chat-box"
                  ]
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: { "font-weight": "bold" },
                      attrs: {
                        align:
                          _vm.currentUser === chat.senderName ? "right" : "left"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(chat.senderName) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  chat.type === "TEXT"
                    ? _c(
                        "p",
                        {
                          attrs: {
                            align:
                              _vm.currentUser === chat.senderName
                                ? "right"
                                : "left"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(chat.message) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  chat.type === "DOCUMENT"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            align: "left",
                            round: "",
                            icon: "el-icon-download"
                          },
                          on: {
                            click: function($event) {
                              return _vm.downloadChatAttachment(chat)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(chat.message) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "12px" },
                      attrs: {
                        align:
                          _vm.currentUser === chat.senderName ? "right" : "left"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.formatTime(chat.timeSend)) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chat-form" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "Enter Chat Message Here",
                          rows: 2,
                          type: "textarea"
                        },
                        model: {
                          value: _vm.formModel.chatText,
                          callback: function($$v) {
                            _vm.$set(_vm.formModel, "chatText", $$v)
                          },
                          expression: "formModel.chatText"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-button-group",
                        [
                          _c("el-button", {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-s-promotion"
                            },
                            on: { click: _vm.sendMessage }
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-paperclip" },
                            on: { click: _vm.openDocumentDialog }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.page === 3
      ? _c("div", { staticClass: "chat-dialog" }, [
          _c(
            "div",
            {
              staticClass: "chat-dialog-content",
              staticStyle: { width: "60%" }
            },
            [
              _c("h3", [_vm._v("Select User")]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "max-height": "20%", width: "100%" } },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.userForm, "label-width": "120px" } },
                    [
                      _vm.selectUserType == "GROUP"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Group Name" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Input Group Name" },
                                model: {
                                  value: _vm.userForm.groupName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.userForm, "groupName", $$v)
                                  },
                                  expression: "userForm.groupName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isChatUser
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Vendor" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Search Vendor" },
                                on: {
                                  input: _vm.debounceLoadUserList,
                                  focus: _vm.debounceLoadUserList
                                },
                                model: {
                                  value: _vm.userForm.searchVendor,
                                  callback: function($$v) {
                                    _vm.$set(_vm.userForm, "searchVendor", $$v)
                                  },
                                  expression: "userForm.searchVendor"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "select-user-list" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingUserList,
                          expression: "loadingUserList"
                        }
                      ],
                      staticStyle: { width: "100%", "margin-bottom": "50px" },
                      attrs: {
                        data: _vm.chatUsers,
                        stripe: "",
                        "highlight-current-row": ""
                      },
                      on: {
                        "selection-change": _vm.onUserSelectionChage,
                        "current-change": _vm.onUserChange
                      }
                    },
                    [
                      _vm.selectUserType == "GROUP"
                        ? _c("el-table-column", {
                            attrs: { type: "selection", width: "55" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Name", width: "180" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var row = ref.row
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.userDisplayName(row)))
                                  ]),
                                  _c("br")
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          310137318
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Vendor",
                          width: "180",
                          prop: "cVendorName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button-group",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "danger" },
                          on: {
                            click: function($event) {
                              _vm.page = 1
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-close" }),
                          _c("span", [_vm._v("Close")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.createRoom }
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _c("span", [_vm._v("Crate Room")])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.openUploadDocument
      ? _c("div", { staticClass: "chat-dialog" }, [
          _c(
            "div",
            {
              staticClass: "chat-dialog-content",
              staticStyle: { width: "40%" }
            },
            [
              _c("el-button", {
                attrs: { size: "mini", icon: "el-icon-close", circle: "" },
                on: {
                  click: function($event) {
                    _vm.openUploadDocument = false
                  }
                }
              }),
              _vm._v(" "),
              _c("h5", [_vm._v("Select Dialog Modal")]),
              _vm._v(" "),
              _c("attachment", { on: { uploaded: _vm.sendChatWithAttachment } })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }